import { render, staticRenderFns } from "./WithdrawComplete.vue?vue&type=template&id=4fd000d3&lang=pug&"
import script from "./WithdrawComplete.vue?vue&type=script&lang=ts&"
export * from "./WithdrawComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports